let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8TpxS")).then(() => parcelRequire('WpfYQ'));